import React from 'react';

interface SpaceProps {
  mt?: number;
  mb?: number;
  ml?: number;
  mr?: number;
}

export const Space = ({ mt = 0, mb = 0, mr = 0, ml = 0 }: SpaceProps) => (
  <div
    style={{ marginTop: mt, marginBottom: mb, marginRight: mr, marginLeft: ml }}
  />
);
